import Vue from "vue";
import App from "./App.vue";
import routes from "./router";

import VueAwesomeSwiper from "vue-awesome-swiper";
import 'swiper/swiper-bundle.css'

import store from "./store";

import Meta from 'vue-meta';

Vue.use(Meta);

import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_URL;

import VueAgile from "vue-agile-carousel";

Vue.use(VueAgile);

import vueVimeoPlayer from "vue-vimeo-player";
Vue.use(vueVimeoPlayer);

import Vuex from "vuex";
Vue.use(Vuex);

import moment from "moment";
Vue.prototype.moment = moment;

Vue.config.productionTip = false;

Vue.use(VueAwesomeSwiper);

import '../v2/src/styles/app.scss'
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import DayJs from "../v2/src/plugins/dayjs";

import VueScreen from "vue-screen";
Vue.use(VueScreen);

Vue.use(DayJs);
global.$t = Vue.t;

new Vue({
    router: routes,
    store,
    render: (h) => h(App),
}).$mount("#app");